import { PipeTransform, Pipe } from "@angular/core"
import { IWriter } from "graphql/queries/keyword.queries"

@Pipe({
  name: 'filterPreferredWriters'
})

export class FilterPreferredWriters implements PipeTransform {
  transform(value: IWriter[], filterStr: string): any[] {
    if (!filterStr) return value
    return value.filter(writer => writer.displayName.toLowerCase().includes(filterStr.toLowerCase()))
  }
}
